import Component from '../core/Component'
import EventBus from '../core/EventBus'
import enquire from 'enquire.js'
import { queries } from '../core/config'

const ACTIVE = 'is-active'

export default class Hamburger extends Component {

    static States = {
        ACTIVE
    }

    constructor(element) {
        super(element)

        this.enquireHandler = {
            match: ::this.reset
        }
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
        enquire.register(queries.largeUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
    }

    reset() {
		console.log('closing?');
        this.element.classList.remove(ACTIVE)
    }

    handleClick(event) {
        event.preventDefault()

		const headerClose = document.getElementsByClassName('header-msg__close').item(0);

		if (headerClose) {
			headerClose.classList.toggle('header-msg__close--hidden');
		}

		this.element.classList.toggle(ACTIVE);

        EventBus.emit('nav:toggle')
    }

}
